// extracted by mini-css-extract-plugin
export default {"box":"MyAddressSearch_box__XaeWS","input":"MyAddressSearch_input__M22t-","icon":"MyAddressSearch_icon__m22fs"};